import React, {Component} from 'react';
import Styles from './style.css';
import {BeatLoader} from 'react-spinners';
import cx from "classnames";
import {dataRegister} from "../../services/dataRegister";
import UserCampaignHistoryItem from "../user-campaigns-history-item/component"
import {userRegister} from "../../services/userRegister";
import {tokenRegister} from "../../services/tokenRegister";
import {langRegister} from "../../services/langRegister";
import {demoRegister} from "../../services/demoRegister";
import {salesChannelRegister} from "../../services/salesChannelRegister";
import LanguageButton from "../language-button/component";
import * as moment from 'moment'
import {agentRegister} from "../../services/agentRegister";
import ReactGA from "react-ga";
import ReactGA4 from 'react-ga4';
import ReactPixel from "react-facebook-pixel";

class userCampaignsHistory extends Component {

    constructor(props) {
        super(props);
        this.state = {
            campaigns: [],
            isLoading: true,
            search: "",
            per_page: 10,
            page: 0,
            isLoadingButton: false,
            show_loadmore: true
        };
    };

    componentDidMount() {
        //GOOGLE ANALYTICS
        if (dataRegister.api.primehit !== "https://api.devprimehit.com/v1") {
            ReactGA.pageview('/user/campaigns/history');
            ReactGA4.send({ hitType: "pageview", page: "/user/campaigns/history" });
        }
        //FACEBOOK PIXEL
        if (dataRegister.api.primehit !== "https://api.devprimehit.com/v1") {
            ReactPixel.pageView();
        }
        this._updateCampaigns();
        this._updateUserData();
    }

    _updateUserData() {
        let user = userRegister.get();
        if (user) {
            this.setState({user_email: user.email, reseller: user.reseller, inhouse: user.inhouse});
        }
    }

    _updateCampaigns() {
        dataRegister.campaigns(salesChannelRegister.get('market'), langRegister.lang(), "ended,terminated_ended,terminated_renew,terminated,ended_renew?page=" + this.state.page + "&per_page=" + this.state.per_page).then((response) => {
            if (response.constructor === Array) {
                this.setState({campaigns: response, isLoading: false, error: false, page: this.state.page + 1}, () => {
                    if (response.length < 10) {
                        this.setState({show_loadmore: false});
                    }
                });
            } else {
                this.setState({isLoading: false});
            }
        }, (error) => {
            if (error.status === 401) {
                this._signOut();
            } else {
                this.setState({isLoading: false, error: true});
            }
        });
    }

    _loadMore() {
        this.setState({isLoadingButton: true}, () => {
            dataRegister.campaigns(salesChannelRegister.get('market'), langRegister.lang(), "ended,terminated_ended,terminated_renew,terminated,ended_renew?page=" + this.state.page + "&per_page=" + this.state.per_page).then((response) => {
                if (response.constructor === Array) {
                    if (response.length > 0) {
                        let campaigns = this.state.campaigns.concat(response);
                        this.setState({
                            campaigns: campaigns,
                            isLoadingButton: false,
                            error: false,
                            page: this.state.page + 1
                        }, () => {
                            if (response.length < 10) {
                                this.setState({show_loadmore: false});
                            }
                        });
                    } else {
                        this.setState({isLoadingButton: false, error: false, show_loadmore: false});
                    }
                } else {
                    this.setState({isLoadingButton: false});
                }
            }, (error) => {
                if (error.status === 401) {
                    this._signOut();
                } else {
                    this.setState({isLoadingButton: false, error: true});
                }
            });
        });
    }

    _signOut() {
        demoRegister.remove();
        userRegister.remove();
        tokenRegister.remove();
        agentRegister.remove();
        this.props.history.push("/" + salesChannelRegister.get('market') + "/" + langRegister.lang() + "/login");
    }

    _new() {
        try {
            this.props.history.push("/" + salesChannelRegister.get('market') + "/" + langRegister.lang());
        } catch (error) {
        }
    }

    _filter() {
        let array = this.state.campaigns.filter((item) => {
            if ((this.state.reseller || this.state.inhouse) && item.ref !== null) {
                return item.industry.toLowerCase().indexOf(this.state.search.toLowerCase()) !== -1 || item.company_name.toLowerCase().indexOf(this.state.search.toLowerCase()) !== -1 || item.ref.toLowerCase().indexOf(this.state.search.toLowerCase()) !== -1 || JSON.stringify(item.id).indexOf(this.state.search.toLowerCase()) !== -1;
            } else if ((this.state.reseller || this.state.inhouse) && item.ref === null) {
                return item.industry.toLowerCase().indexOf(this.state.search.toLowerCase()) !== -1 || item.company_name.toLowerCase().indexOf(this.state.search.toLowerCase()) !== -1 || JSON.stringify(item.id).indexOf(this.state.search.toLowerCase()) !== -1;
            } else {
                return item.industry.toLowerCase().indexOf(this.state.search.toLowerCase()) !== -1 || JSON.stringify(item.id).indexOf(this.state.search.toLowerCase()) !== -1;
            }
        });
        return array;
    }

    _sort() {
        let array = [];

    }

    _renderText(item) {
        return langRegister.get("user-campaigns-running", item);
    }

    render() {
        return (
            <div>
                <div className={Styles.contentHeader}>
                    <div className={Styles.contentHeaderSearch}>
                        <input value={this.state.search}
                               onChange={(event) => this.setState({search: event.target.value})}
                               placeholder={this._renderText("item_1")} className={Styles.contentHeaderSearchInput}/>
                        {
                            salesChannelRegister.get('name') === "propertybooster" &&
                            <img className={Styles.contentHeaderSearchInputIcon} src={require("../../assets/images/search_icon_2.png")}/>
                        }
                        {
                            salesChannelRegister.get('name') === "yieldlock" &&
                            <img className={Styles.contentHeaderSearchInputIcon} src={require("../../assets/images/search_icon_2_yl.png")}/>
                        }
                        {
                            salesChannelRegister.get('name') === "boostabostad" &&
                            <img className={Styles.contentHeaderSearchInputIcon} src={require("../../assets/images/search_icon_boostabostad.png")}/>
                        }
                    </div>
                    <LanguageButton props={this.props}/>
                    <div onClick={() => this._signOut()} className={Styles.contentHeaderButton}>
                        {this._renderText("item_2")}
                    </div>
                </div>
                <div className={Styles.container}>
                    {
                        !this.state.isLoading && !this.state.error &&
                        <div onClick={() => this._new()} className={Styles.button}>
                            <span className={Styles.buttonPlus}>+</span> <span
                            className={Styles.buttonText}>{this._renderText("item_3")}</span>
                        </div>
                    }
                    {
                        !this.state.isLoading && this.state.campaigns.length > 0 && !this.state.error &&
                        this._filter().sort((a, b) => b.id - a.id).map((prop, key) => {
                            return (
                                <div key={prop.id}>
                                    <UserCampaignHistoryItem props={this.props} key={key} data={prop}/>
                                </div>
                            )
                        })
                    }
                    {
                        !this.state.isLoading && !this.state.error && this.state.show_loadmore &&
                        <div className={Styles.loadMoreButtonContainer}>
                            <div className={Styles.loadMoreButton} onClick={() => {
                                this._loadMore()
                            }}>
                                {
                                    this.state.isLoadingButton &&
                                    <BeatLoader size={10} color={'#ffffff'} loading={true}/>
                                }
                                {
                                    !this.state.isLoadingButton &&
                                    <img className={Styles.loadMoreButtonIcon}
                                         src={require("../../assets/images/plus_sign_white_small.png")}/>
                                }
                            </div>
                        </div>
                    }
                    {
                        !this.state.isLoading && this.state.campaigns.length < 1 && !this.state.error &&
                        <div className={Styles.noResult}>
                            {this._renderText("item_5")}
                        </div>
                    }
                    {
                        !this.state.isLoading && this.state.error &&
                        <div className={Styles.noResult}>
                            {this._renderText("item_6")}
                        </div>
                    }
                    {
                        this.state.isLoading &&
                        <div className={Styles.loader}>
                            <BeatLoader size={30} color={'var(--first-color)'} loading={true}/>
                        </div>
                    }
                </div>
            </div>
        );
    }
}

export default userCampaignsHistory;


// WEBPACK FOOTER //
// ./src/components/user-campaigns-history/component.js